import React, { useEffect } from 'react';

import { useRef } from "react";
import { useLocation } from "react-router-dom";

import Form from './Form';
import { MDBCard, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import MettitiInContatto from './mettitiIncontatto';

export default function StartForm({title, servizio_name}) {
	const location = useLocation();
    const sectionRef = useRef(null);

    useEffect(() => {
        if (location.hash) {
        const id = location.hash.slice(1);

        sectionRef.current &&
            sectionRef.current.id === id &&
            sectionRef.current.scrollIntoView();
        }
    }, [location]);

	return (
		<MDBRow ref={sectionRef} id="formContatti" className='customRow'>
			<MDBCol md='8' className='col-example'>
				<MDBCard className='p-4'>
					<div className="title-box-2">
						{servizio_name ? <h1 className='title_richiesta'>{servizio_name}</h1> : null}
						{title ? <h2 className="title-left">{title}</h2> : null}
					</div>
					<div className="app_form">
						<Form />
					</div>
				</MDBCard>
			</MDBCol>
			<MDBCol md='4' className='col-example'>
				<MDBCard className='p-4'>
					<MettitiInContatto />
				</MDBCard>
			</MDBCol>
		</MDBRow>
	);
}


